import { FastForwardIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { useQuizContext } from "@/router/test/_hooks/QuizContext";

import { OptionButton } from "./OptionButton";
import { QuizHeader } from "./QuizHeader";
import WordCard from "./WordCard";

export function QuizView() {
  const {
    currentQuestion,
    currentIndex,
    questions,
    countdown,
    pendingSelectedOptionIndex,
    isMuted,
    exitToList,
    selectOption,
    skipToNext,
    toggleMute,
  } = useQuizContext();

  if (!currentQuestion || questions.length === 0) {
    return null;
  }

  return (
    <Card className="flex w-full h-full min-h-0 flex-col overflow-hidden bg-primary-background pt-2 sm:pt-5 sm:mx-auto sm:max-w-4xl sm:rounded-2xl sm:h-fit sm:shadow-lg sm:min-w-lg">
      {/* 퀴즈 헤더 */}
      <QuizHeader
        currentIndex={currentIndex}
        totalCount={questions.length}
        isMuted={isMuted}
        onExit={exitToList}
        onToggleMute={toggleMute}
      />

      {/* 퀴즈 본문 */}
      <CardContent className="flex flex-1 min-h-0 flex-col items-center gap-6 px-5 sm:px-4 sm:aspect-video sm:max-h-fit">
        {/* 단어 */}
        <WordCard countdown={countdown} word={currentQuestion.word} />

        {/* 옵션 버튼 */}
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-3">
          {currentQuestion.options.map((option, idx) => (
            <OptionButton
              key={option}
              number={idx + 1}
              meaning={option}
              isSelected={pendingSelectedOptionIndex === idx}
              isDisabled={pendingSelectedOptionIndex !== null}
              onClick={() => selectOption(idx)}
            />
          ))}
        </div>
      </CardContent>

      {/* 퀴즈 푸터 */}
      <CardFooter className="flex items-center justify-center border-t-0 bg-transparent p-5 pb-6">
        <Button
          variant="ghost"
          size="lg"
          className="bg-white rounded-md flex items-center justify-center px-12 py-6"
          onClick={skipToNext}
        >
          <FastForwardIcon className="size-8 text-muted-foreground" />
        </Button>
      </CardFooter>
    </Card>
  );
}
